import type { IdentityLifecycleSignal } from "@repo/identity";
import { isIdentityGraphClientEnabled } from "@repo/identity";
import { orpcClient } from "@shared/lib/orpc-client";

/**
 * Records a lifecycle signal once per browser tab session for a sqid + storage key
 * (post-auth flows where the visitor cookie may not yet reflect the account).
 */
export function recordIdentityLifecycleSignalOnceForSqid(
	sqid: string,
	signal: IdentityLifecycleSignal,
	storageKey: string,
): void {
	if (!sqid.trim() || !isIdentityGraphClientEnabled()) {
		return;
	}
	if (typeof window === "undefined") {
		return;
	}
	if (window.sessionStorage.getItem(storageKey) === "1") {
		return;
	}

	void orpcClient.identity
		.recordLifecycleSignal({ sqid: sqid.trim(), signal })
		.then(() => {
			window.sessionStorage.setItem(storageKey, "1");
		})
		.catch(() => {
			// Best-effort lifecycle signal.
		});
}
